export const PREVIEW_FILE_FORMATS = ['pdf', 'png', 'jpeg', 'jpg'] as const
export const MSFT_FILE_FORMATS = ['ppt', 'pptx', 'doc', 'docx', 'xls', 'xlsx'] as const
export type PreviewFileFormat = (typeof PREVIEW_FILE_FORMATS)[number]

export const MSFT_VIEWER_EMBED_URL = 'https://view.officeapps.live.com/op/view.aspx?src='

export function getFileFormat(fileName: string): string {
  return fileName.split('.').pop()?.toLowerCase() || ''
}

export function isPreviewableExtension(extension: string): boolean {
  return [...PREVIEW_FILE_FORMATS, ...MSFT_FILE_FORMATS].includes(extension.toLowerCase() as PreviewFileFormat)
}

export function isMicrosoftDocument(extension: string): boolean {
  return MSFT_FILE_FORMATS.includes(extension.toLowerCase() as (typeof MSFT_FILE_FORMATS)[number])
}
